/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PageSharedFollowingFanProjection } from '../models/PageSharedFollowingFanProjection';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DashboardSharedFollowingListRestEndpointService {
    /**
     * @returns PageSharedFollowingFanProjection OK
     * @throws ApiError
     */
    public static dashboardGetSharedFollowingListFans({
        fanName,
        page,
        size = 20,
    }: {
        fanName?: string,
        page?: number,
        size?: number,
    }): CancelablePromise<PageSharedFollowingFanProjection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/list-feature/shared-following-list',
            query: {
                'fanName': fanName,
                'page': page,
                'size': size,
            },
        });
    }
}
